import { Plus, X } from "lucide-react";
import { WorkspaceDocument } from "../types";

interface DocumentTabsProps {
  documents: WorkspaceDocument[];
  activeId: string;
  /** Tabs linked to a disk file with changes not yet written to it. */
  dirtyIds: Set<string>;
  onSelect: (id: string) => void;
  onClose: (id: string) => void;
  onNew: () => void;
}

export const DocumentTabs = ({ documents, activeId, dirtyIds, onSelect, onClose, onNew }: DocumentTabsProps) => (
  <div className="tab-strip" role="tablist" aria-label="Open documents">
    <div className="tab-strip-scroll">
      {documents.map((document) => (
        <div className={document.id === activeId ? "doc-tab active" : "doc-tab"} key={document.id}>
          <button
            type="button"
            role="tab"
            aria-selected={document.id === activeId}
            className="doc-tab-label"
            title={document.name}
            onClick={() => onSelect(document.id)}
          >
            {dirtyIds.has(document.id) && <span className="doc-tab-dot" title="Unsaved file changes" />}
            <span className="doc-tab-name">{document.name}</span>
          </button>
          <button
            type="button"
            className="doc-tab-close"
            aria-label={`Close ${document.name}`}
            title="Close tab"
            onClick={() => onClose(document.id)}
          >
            <X size={13} />
          </button>
        </div>
      ))}
    </div>
    <button type="button" className="doc-tab-new" aria-label="New document tab" title="New document" onClick={onNew}>
      <Plus size={15} />
    </button>
  </div>
);
